class MenuItem {
  constructor(title, url) {
    this.title = title;
    this.url = url;
  }
}

export const MenuLinks = [
  {
    title: "Fantasy",
    url: "/fantasy",
    subNav: [
      new MenuItem("PGA", "/fantasy/golf"),
      new MenuItem("NFL", "/fantasy/nfl"),
      // new MenuItem("NBA", "/fantasy/nba"),
      new MenuItem("CFB", "/fantasy/cfb"),
      new MenuItem("Educational Information", "/fantasy/educational"),
      new MenuItem("Content Schedule", "/content-schedule"),
      new MenuItem("Affiliates", "/affiliates"),
    ],
  },
  {
    title: "Betting",
    url: "/betting",
    subNav: [
      new MenuItem("PGA", "/betting/golf"),
      new MenuItem("NFL", "/betting/nfl"),
      new MenuItem("CFB", "/betting/cfb"),
      new MenuItem("Horses", "/betting/horses"),
      new MenuItem("Futures", "/betting/futures"),
      new MenuItem("Recaps", "/betting/recaps"),
      new MenuItem("Affiliates", "/affiliates"),
    ],
  },
  {
    title: "Tools",
    url: "#",
    wide: true,
    subNav: {
      "All Sports": [new MenuItem("Green Machine", "/tools/green-machine")],
      PGA: [
        new MenuItem("PGA Model Builder", "/tools/pga-model"),
        new MenuItem("PGA Research Center", "/tools/pga-research"),
        new MenuItem(
          "PGA Live Tournament Tools",
          "/tools/pga-live-tournament-tool"
        ),
        new MenuItem("PGA Live Contest Tracker", "/tools/pga-sweat-tool"),
      ],
      NFL: [
        new MenuItem("NFL Stat Engine", "/tools/nfl-engine"),
        new MenuItem("NFL Redzone Advantage", "/tools/redzone-advantage"),
        new MenuItem("NFL Scouting Report", "/tools/scouting-report"),
        new MenuItem("NFL Projections", "/tools/nfl/projections"),
      ],
    },
  },
  {
    title: "Chat",
    url: "#",
    subNav: [new MenuItem("Slack Premium Chat", "/slack")],
  },
  {
    title: "Podcasts",
    url: "/podcasts",
    subNav: [],
  },
];
